export default __webpack_public_path__ + "static/media/sign-in-image.9952dd7e.jpg";